<div
  class="d-flex vw-100 justify-content-center align-items-center offline-bar"
  [@growDown]="{ value: true, params: { heightContainer: height } }"
  *ngIf="(isOnLine$ | async) === false"
>
  <i class="icon icon-cloud-slash me-2"></i>
  <div translate>You're currently offline</div>
</div>
